import type { Category as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';
import * as Subcategory from './Subcategory';

/**
 * A category and the subcategories under it, as the superadmin genre screens read and write them on
 * the internal (VP staff) schema.
 *
 * The category owns its subcategories rather than the screens holding a flat list: the subcategory
 * tab renders one category's children, and a saved subcategory is folded into its parent. There is
 * no query that returns subcategories on their own.
 */

export type Category = {
  id: string;
  name: string;
  subcategories: Subcategory.Subcategory[];
};

/**
 * `subcategories` is non-null on the schema, but map it defensively anyway: a category that arrived
 * without it would otherwise hand the screens an `undefined` where `Category` promises an array,
 * and every `.length` and `v-for` on it would throw.
 */
export const fromGql = (item: GQLItem): Category => ({
  ...take<Pick<Category, 'id' | 'name'>>(item, 'id', 'name'),
  subcategories: item.subcategories?.map(Subcategory.fromGql) ?? [],
});
